$ = require 'jquery'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'
l = require 'lib/localize'
{ maybeDisplayLimitsErrorOnCardAdd } = require 'views/card/card-limits-error'
moment = require 'moment'
DatePickerView = require 'views/card/date-picker-view'
timeFormat = 'LT'
parseFormat = [timeFormat, 'h:mm A']
isTimeStringValid = (string) -> moment(string, parseFormat).isValid()

module.exports = class CalendarCardComposerView extends View
  className: 'calendar-card-composer'

  initialize: (opts) ->
    @board = @model.getBoard()
    @newCalendarEnabled = opts.newCalendarEnabled

  events:
    'change .js-select-list': 'updatePositionList'
    'change .js-select-position': 'renderValues'
    'click .js-add-card': 'addCard'
    'input .js-dpicker-time-input': 'validateTimeInput'
    'change .js-dpicker-time-input': 'normalizeTimeInput'

    'keydown': 'keydownEvent'

  viewTitleKey: 'add card'

  setDate: (@date) ->
    if @newCalendarEnabled
      @date
    else
      # Due time defaults to the last selected due time otherwise use 12pm.
      lastDueDate = DatePickerView.lastDueDate
      if lastDueDate
        @date.setHours lastDueDate.getHours(), lastDueDate.getMinutes()
      else
        @date.setHours(12)

  remove: ->
    data =
      title: @$('.js-card-title').val()
      idList: @$('.js-select-list').val()
      pos: @$('.js-select-position').val()

    @model
      .set(data)
      .save()
    super

  render: ->
    data =
      title: @model.get('title')
      dueTime: moment(@date).format(timeFormat)

    @$el.html(templates.fill('popover_card_from_calendar', data))
    @updateListList()
    @updatePositionList()

    setTimeout =>
      Util.setCaretAtEnd(@$('.js-card-title')[0])
    , 5

    @

  keydownEvent: (e) ->
    if Keyboard.getKey(e) == Keys.Enter
      @addCard(e)
      return

  addCard: (e) ->
    Util.stop(e)

    cardTitle = $.trim @$('.js-card-title').val()
    return if !cardTitle

    list = @selectedList()
    options = {
      $elem: $(e.target),
      destinationBoard: @board,
      destinationList: list,
    }
    if maybeDisplayLimitsErrorOnCardAdd(options)
      return

    PopOver.hide()
    @model.clearItems()
    @model.set('pos', 'bottom')

    posIndex = parseInt @$('.js-select-position').val()

    time = @selectedTimeMoment()
    @date.setHours time.hour(), time.minute()
    DatePickerView.lastDueDate = @date

    cardData =
      closed: false
      dateLastActivity: new Date()
      due: @date.toString()
      idList: list.id
      pos: list.calcPos(posIndex)
      name: cardTitle

    list.cardList.create(cardData)

  updateListList: ->
    $selectList = @$('.js-select-list')

    $selectList.empty()

    lists = @board.listList.models
    _.each lists, (list) ->
      $('<option>').val(list.id).text(list.get('name')).appendTo($selectList)

    $selectList.val(@model.get('idList'))
    if !$selectList.val()
      $selectList.find('option').first().prop('selected', true)

    @renderValues()

  updatePositionList: ->
    $posList = @$('.js-select-position')
    list = @selectedList()

    $posList.empty()

    if list?
      numCards = list.cardList.length
      indexes = [0..numCards]
      _.each indexes, (index) ->
        tag = switch index
          when 0 then ' (Top)'
          when indexes.length - 1 then ' (Bottom)'
          else ''

        $('<option>').val(index).text((index + 1) + tag).appendTo($posList)

      $posList.val(@model.get('pos'))
      if !$posList.val()
        $posList.find('option').last().prop('selected', true)

    @renderValues()

  selectedList: ->
    idList = @$('.js-select-list').val()
    _.findWhere @board.listList.models, { id: idList }

  renderValues: ->
    list = @selectedList()
    $listValue = @$('.js-list-value')
    $posValue = @$('.js-pos-value')

    # It's possible for a board to have no lists
    if list?
      $listValue.text(list.get('name'))
      pos = parseInt @$('.js-select-position').val()
      $posValue.text(pos + 1)
    else
      $listValue.empty().append $('<i></i>').text(l('no lists'))
      $posValue.empty().append $('<i></i>').text(l('n/a'))

    @$('.js-add-card,.js-card-title').prop('disabled', !list?)

    return

  validateTimeInput: ->
    @$timeInput().toggleClass 'input-error', !@isTimeInputValid()

  normalizeTimeInput: ->
    @$timeInput().val @selectedTimeMoment().format(timeFormat)
    @validateTimeInput()

  selectedTimeMoment: ->
    if @isTimeInputValid()
      moment(@$timeInput().val(), parseFormat)
    else
      moment().hours(12).minutes(0)

  $timeInput: -> @$('.js-dpicker-time-input')

  isTimeInputValid: -> isTimeStringValid @$timeInput().val()



// WEBPACK FOOTER //
// ./app/scripts/views/card-composer/calendar-card-composer-view.coffee